export default "/_next/static/chunks/fonts/WhitneySSm-MediumItalic-Pro_Web-da42eaebd63cd19579b8893a525d3ba9.woff2";